import React, { useEffect, useState, useRef } from "react";
import { View, Text, TouchableOpacity, ActivityIndicator, ScrollView, Alert } from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as DocumentPicker from 'expo-document-picker';
//import * as ImagePicker from 'expo-image-picker';
//import { Camera } from 'expo-camera';
import { Feather } from '@expo/vector-icons';

import HeaderDefault from "../../components/HeaderDefault";
import InputDefault from "../../components/Form/InputDefault";
import MaskedInputDefault from "../../components/Form/MaskedInputDefault";
import ScreenLoader from '../../components/ScreenLoader'

import { LinearGradient } from "expo-linear-gradient";
import { toast } from "../../utils/toast";

import * as mime from 'react-native-mime-types';
import api from "../../services/api";

import styles from "./styles";
import cepService from "../../services/cepService";

import ups3 from '../../services/uploadS3'

const UpdateRegistration = ({ navigation }) => {
  //const camRef = useRef();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCpf] = useState("");

  const [nameLegalResponsible, setNameLegalResponsible] = useState("");
  const [cpfLegalResponsible, setCpfLegalResponsible] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [socialReason, setSocialReason] = useState("");

  const [rg, setRg] = useState("");
  const [cep, setCep] = useState("");
  const [street, setStreet] = useState("");
  const [number, setNumber] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [complement, setComplement] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [level, setLevel] = useState(1);
  const [pj, setPj] = useState(false);
  const [socialContractLegalResponsible, setSocialContractLegalResponsible] = useState(null);
  const [proofAddress, setProofdAddress] = useState(null);
  const [hasPermission, setHasPermission] = useState(null);
  // const [type, setType] = useState(Camera.Constants.Type.front);

  const inputNumber = useRef(null);

  useEffect(() => {
    getDataUsers();
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     const { status } = await Camera.requestPermissionsAsync();
  //     setHasPermission(status === 'granted');
  //   })();
  // }, []);

  // if (hasPermission === false) {
  //   return Alert.alert(
  //     "Câmera",
  //     "Precimos de acesso a sua câmera.",
  //     [
  //       { text: "OK" }
  //     ],
  //   );
  // }

  const getDataUsers = async () => {
    setIsLoading(true);
    const token = await AsyncStorage.getItem('JWT_TOKEN');

    api.get(`/clients/getDetails/client`, { headers: { 'Authorization': `Basic ${token}` } })
      .then((res) => {
        const user = res.data.user[0];
        const client = res.data.user[0].client;

        setNameLegalResponsible(client.name_legal_responsible || "")
        setCpfLegalResponsible(client.cpf_legal_responsible || "")
        setSocialReason(client.social_reason || "")
        setCnpj(client.cnpj || "")

        setName(client.first_name || "");
        setEmail(client.user.email || "");
        setCpf(client.cpf || "");
        setRg(client.rg_number || "");
        setCep(user.address.zip_code || "");
        setStreet(user.address.street_name || "");
        setNumber(user.address.street_number || "");
        setDistrict(user.address.district || "");
        setCity(user.address.city || "");
        setState(user.address.state || "");
        setComplement(user.address.additional_information || "");
        setLevel(client.level || "");
        setPj(client.is_pj || false);

        if (res.data.proofAddress)
          setProofdAddress(res.data.proofAddress);

        setIsLoading(false);
      })
      .catch((error) => {
        toast("Houve um erro, tente novamente.", "#DA1414");
        setIsLoading(false);
      })
  }

  const save = async () => {
    setIsLoading(true);
    const token = await AsyncStorage.getItem('JWT_TOKEN');

    if (level === 1) {
      const data = {
        name,
        email,
        cpf,
        cnpj,
        social_reason: socialReason,
        name_legal_responsible: nameLegalResponsible,
        cpf_legal_responsible: cpfLegalResponsible,
        rg,
        cep,
        street,
        number,
        district,
        city,
        state,
        complement
      };

      await api.patch(`/clients/update/client`, data, { headers: { 'Authorization': `Basic ${token}` } })
        .then((res) => {
          //    console.log(res.data, data, "2")
          toast("Dados atualizados.", "#080");

          setIsLoading(false);
        })
        .catch((error) => {
          toast("Houve um erro, tente novamente.", "#DA1414");
          setIsLoading(false);
          console.log(error);
        })
    }

    if (level === 2) {
      const fileId = proofAddress && proofAddress.id;
      const data = {
        name,
        email,
        cpf,
        cnpj,
        social_reason: socialReason,
        name_legal_responsible: nameLegalResponsible,
        cpf_legal_responsible: cpfLegalResponsible,
        rg,
        cep,
        street,
        number,
        district,
        city,
        state,
        complement,
        fileId,
      };

      await api.patch(`/clients/update/client`, data, {
        headers: {
          'Authorization': `Basic ${token}`
        }
      })
        .then((res) => {
          toast("Dados atualizados.", "#080");
          setIsLoading(false);
        })
        .catch((error) => {
          toast("Houve um erro, tente novamente.", "#DA1414");
          setIsLoading(false);
          console.log(error);
        })
    }
  }

  const pickDocument = async () => {
    let result = await DocumentPicker.getDocumentAsync({});

    if (result.cancelled) {
      return false;
    }

    let localUri = result.uri;
    let filename = localUri.split('/').pop();

    let match = /\.(\w+)$/.exec(filename);
    let type = match ? `image/${match[1]}` : `image`;

    setSocialContractLegalResponsible(result);
  }

  const pickDocumentAddress = async () => {
    setIsLoading(true);

    const response = await DocumentPicker.getDocumentAsync();

    if (response.type == 'cancel') {
      console.log('User cancelled document picker');

    } else if (!response.uri) {
      console.log('DocumentPicker Error Uri: ', response.uri);
    } else {
      let localUri = "file://" + response.uri;
      let filename = localUri.split('/').pop();

      let match = /\.(\w+)$/.exec(filename);
      let type = mime.lookup(localUri);



      var file = {
        uri: localUri.replace(/%/g, '%25'),
        name: response.name,
        type,
        size: response.size,
        path: 'ProofAddress'
      };
      await ups3(file).then(res => {
        if (res) {
          file.id = res.id;
          setProofdAddress(file);
        } else {
          toast("Houve um erro com arquivo.", "#DA1414");
        }
        setIsLoading(false);
      })
    }
  }

  const onCepChange = (value) => {
    setCep(value);
    let cepReplace = value.replace(/[^0-9]/g, '');

    if (cepReplace.length == 8) {
      cepService.getAddressFromCEP(cepReplace).then((response) => {
        if (response.status == 200) {
          setStreet(response.data.logradouro);
          setCity(response.data.localidade);
          setState(response.data.uf);
          setDistrict(response.data.bairro);
          setComplement(response.data.complemento);
          inputNumber?.current?.focus();
        }
      });
    }
  }
  return (
    <>
      <View style={{ flex: 1 }}>
        <ScreenLoader loading={isLoading} />
        <HeaderDefault title={"Atualizar cadastro"} />
        <ScrollView>
          <View style={styles.content}>
            {pj ? <><InputDefault
              editable={false}
              value={socialReason}
              onValueChange={(value) => setSocialReason(value)}
              placeholder={"Razão social"}
            />
              <InputDefault
                editable={false}
                value={cnpj}
                onValueChange={(value) => setCnpj(value)}
                placeholder={"CNPJ"}
              />
              <InputDefault
                editable={false}
                value={nameLegalResponsible}
                onValueChange={(value) => setNameLegalResponsible(value)}
                placeholder={"Nome do responsável"}
              />
              <InputDefault
                editable={false}
                value={cpfLegalResponsible}
                onValueChange={(value) => setCpfLegalResponsible(value)}
                placeholder={"CPF do responsável"}
              />
            </>
              : <><InputDefault
                editable={false}
                value={name}
                onValueChange={(value) => setName(value)}
                placeholder={"Nome"}
              />
                <MaskedInputDefault
                  editable={false}
                  mask="999.999.999-99"
                  keyboardType="numeric"
                  value={cpf}
                  onValueChange={(value) => setCpf(value)}
                  placeholder={"CPF"}
                />
                <InputDefault
                  value={rg}
                  onValueChange={(value) => setRg(value)}
                  placeholder={"RG"}
                /></>
            }
            <InputDefault
              editable={false}
              value={email}
              onValueChange={(value) => setEmail(value)}
              placeholder={"E-mail"}
            />

            {
              level >= 1 ? (
                <>
                  <MaskedInputDefault
                    mask="99999-999"
                    keyboardType="numeric"
                    value={cep}
                    onValueChange={(value) => onCepChange(value)}
                    placeholder={"CEP"}
                  />

                  <InputDefault
                    value={street}
                    onValueChange={(value) => setStreet(value)}
                    placeholder={"Rua"}
                  />

                  <InputDefault
                    value={number}
                    onValueChange={(value) => setNumber(value)}
                    placeholder={"Número"}
                  />

                  <InputDefault
                    value={district}
                    onValueChange={(value) => setDistrict(value)}
                    placeholder={"Bairro"}
                  />

                  <InputDefault
                    value={city}
                    onValueChange={(value) => setCity(value)}
                    placeholder={"Cidade"}
                  />

                  <InputDefault
                    value={state}
                    onValueChange={(value) => setState(value)}
                    placeholder={"Estado"}
                  />

                  {/* <InputDefault
                  value={country}
                  onValueChange={(value) => setCountry(value)}
                  placeholder={"País"}
                /> */}

                  <InputDefault
                    value={complement}
                    onValueChange={(value) => setComplement(value)}
                    placeholder={"Complemento"}
                  />

                  {
                    level >= 2 ? (
                      <View style={styles.containerSocialContract}>
                        <Text style={styles.description}>Comprovante de endereço</Text>
                        <TouchableOpacity style={styles.btnAdd} onPress={pickDocumentAddress}>
                          <Feather name="plus" size={24} color="black" style={styles.iconAdd} />
                        </TouchableOpacity>
                        {
                          proofAddress && (
                            <Text style={{ fontWeight: 'bold', marginTop: 20 }}><Text style={{ fontWeight: 'normal' }}>Arquivo: {proofAddress.name}</Text></Text>
                          )
                        }
                      </View>

                    ) : null
                  }

                  {/* <View style={styles.containerSocialContract}>
                  <Text style={styles.description}>Selfie</Text>

                  <TouchableOpacity style={styles.btnAdd}>
                    <Feather name="plus" size={24} color="black" style={styles.iconAdd} />
                  </TouchableOpacity>
                </View> */}

                  {
                    pj ? (
                      <View style={styles.containerSocialContract}>
                        <Text style={styles.description}>Contrato social</Text>
                        <TouchableOpacity style={styles.btnAdd} onPress={pickDocument}>
                          <Feather name="plus" size={24} color="black" style={styles.iconAdd} />
                        </TouchableOpacity>
                        {
                          socialContractLegalResponsible &&
                          <Text style={{ fontWeight: 'bold', marginTop: 20 }}><Text style={{ fontWeight: 'normal' }}>  Arquivo: {socialContractLegalResponsible.name}</Text></Text>
                        }
                      </View>
                    ) : null
                  }
                </>
              ) : null
            }
          </View>

          <View style={styles.contentBtn}>
            <TouchableOpacity onPress={save}>
              <LinearGradient
                start={{ x: -1, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={["#16195B", "#1FBFB5"]}
                style={styles.btn}
              >
                {isLoading ? (
                  <ActivityIndicator color="#1FBFB5" size="small" />
                ) : (
                  <Text style={styles.textBtn}>Salvar</Text>
                )}
              </LinearGradient>
            </TouchableOpacity>
          </View>

          <View style={styles.contentBtnDelete}>
            {/* <TouchableOpacity onPress={() => navigation.navigate("DeleteAccount")}>
              <Text style={styles.textBtnDelete}>Excluir conta</Text>
            </TouchableOpacity> */}
          </View>
        </ScrollView>
      </View>
    </>
  );
};

export default UpdateRegistration;
